import { render, staticRenderFns } from "./DateObjectDrawer.vue?vue&type=template&id=63da9960&"
import script from "./DateObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./DateObjectDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports